export default function PageLoader() {
  return <div className="page-loading"></div>;
}
